import { ReactNode, useContext } from 'react';
import { DocumentContext, generateVariantValues } from './DocumentContext';
import { css as emotionCSS } from '@emotion/react';
import { Typography } from '@mildang/mui';

const rootStyle = emotionCSS`
  margin-top: 30px;
`;

const ChapterTitle = ({ children }: { children: ReactNode }) => {
  const { variant } = useContext(DocumentContext);
  return (
    <Typography
      css={rootStyle}
      variant={generateVariantValues({
        screen: 'h2' as const,
        dialog: 'h3' as const,
      })(variant)}
    >
      {children}
    </Typography>
  );
};

export default ChapterTitle;
